// Change-order numbering: `{WO#}-101`, `{WO#}-102` … (POs own `{WO#}-001`+ since iter352; iter331 started at 001).
// Reads the trailing integer of every existing CO number so legacy
// `CO-3` and new `W220-003` both count toward the next sequence.
export const coSeq = (coNumber) => {
  const m = String(coNumber || "").match(/(\d+)\s*$/);
  return m ? parseInt(m[1], 10) : 0;
};

export const nextCoNumber = (woNumber, changeOrders) => {
  // COs number from 101 (W222-101) so they never collide with POs, which own 001+ (W222-001).
  const max = (changeOrders || []).reduce((acc, co) => Math.max(acc, coSeq(co.co_number)), 100);
  return `${woNumber || "CO"}-${String(max + 1).padStart(3, "0")}`;
};
